const ROLES = ["NORMAL_USER", "SUPER_ADMIN", "AGENCY", "ADMIN"];

const SECRET_KEY = process.env.REACT_APP_ROLE_KEY;

const encoder = new TextEncoder();

async function getKey() {
  return window.crypto.subtle.importKey(
    "raw",
    encoder.encode(SECRET_KEY),
    {
      name: "HMAC",
      hash: "SHA-256",
    },
    false,
    ["sign"]
  );
}

export async function signRole(role, userId) {
  const key = await getKey();

  const payload = `${role}:${userId}`;

  const signatureBuffer = await window.crypto.subtle.sign(
    "HMAC",
    key,
    encoder.encode(payload)
  );

  const bytes = new Uint8Array(signatureBuffer);

  return Array.from(bytes)
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

export async function verifyRoleFromSignature(signature, userId) {
  for (const role of ROLES) {
    const expectedSignature = await signRole(role, userId);

    if (expectedSignature === signature) {
      return role;
    }
  }

  return null;
}
